import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { HttpClient , HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-updatefees',
  templateUrl: './updatefees.component.html',
  styleUrls: ['./updatefees.component.scss']
})
export class UpdatefeesComponent implements OnInit {
    allfeesdata:any;
    feesform!:FormGroup;
  submitted: boolean=false;
  actiontaken: any;
  addeditmodal:boolean=true;
  formdisable:boolean=true;
  selectedappname: any="";
  selectedappbasic: any;
  selectedappextra: any;
  selectedappid: any;
  constructor(private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder) 
  { }

  ngOnInit(): void {
        if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
          this.router.navigate(['/boardadminlogin']);
        // sessionStorage.clear();
        }
        else  if(sessionStorage.getItem('roleid')=="1"){
        this.router.navigate(['/dashboard']);
      }
     this.getallfees();
     this.feesform = this.formBuilder.group({
          
      applicationname:['',Validators.required],
      applicationbasic:['',Validators.required],
      applicationextra:['',Validators.required],});
  }
  get f() { return this.feesform.controls; 
  }
  getallfees(){
     this.service.post('/Boardadmin_module/getallapplicationsfees',{}).subscribe((res:any)=>{
      // console.log(res.Data)
      if(res.status=="success"){
          this.allfeesdata=res.Data;
         }
         else{
            alert("Something went wrong!, please refresh page.");
            window.location.reload();
         }
      });
  
  }
  getselectedappdetail(selectedapp:any){
      
      let appl:{application_type_requested:any}={
        application_type_requested:selectedapp.value
      }
       this.service.post('/Student_module/getfees',appl).subscribe((res:any)=>{
        if(res.status=="success"){
              this.selectedappid=res.Data[0].feesid;
              this.selectedappname=res.Data[0].application_type_name;
              this.selectedappbasic=res.Data[0].basic_certificate_fees;
              this.selectedappextra=res.Data[0].postal_fees;
              this.addeditmodal=false;
           }
           else{
             alert("Something went wrong, PLease reload page.");
              window.location.reload();
           }
        });
  }
  actiontaking(actiontaken:any){
    this.actiontaken=actiontaken;
    if(this.actiontaken=="Update"){
      
      this.submitted=false;
      this.feesform.controls.applicationname.setValue(this.selectedappname);
      this.feesform.controls.applicationbasic.setValue(this.selectedappbasic);
      this.feesform.controls.applicationextra.setValue(this.selectedappextra);
    }
    else{
      // this.submitted=true;
      this.feesform.reset();
    }
  }
  onSubmit(form:any){
    // console.log(form);
    this.submitted = true;
    if (this.feesform.invalid) {
      alert("Please Fill all details");    
      return;
    }   
    if(this.actiontaken=="Update"){
      this.updatefeesdetails();
    }
    else{
      this.addnewfeesdetails();
    } 
}
updatefeesdetails(){
  let conf=confirm("Are you sure to Update This Application Type?")
  if(conf==true){
      // var app_type=this.feesform.value.applicationname.replace(/ /g, "_");
  let feedata:{feesid:any,application_type:any,application_type_name:any,basic_certificate_fees:any,postal_fees:any}={
    feesid: this.selectedappid,
    application_type: this.feesform.value.applicationname.replace(/ /g, "_"),
    application_type_name: this.feesform.value.applicationname,
    basic_certificate_fees: this.feesform.value.applicationbasic,
    postal_fees: this.feesform.value.applicationextra
  }
  this.service.post('/Boardadmin_module/updateappfees',feedata).subscribe((res:any)=>{
    if(res.status=="success"){
          alert(res.Data);
          window.location.reload();
       }
       else{
         alert(res.Data);
          window.location.reload();
       }
    });
  }  
}
addnewfeesdetails(){
  let conf=confirm("Are you sure to Add This Application Type?")
  if(conf==true){
    let feedata:{application_type:any,application_type_name:any,basic_certificate_fees:any,postal_fees:any}={
      application_type: this.feesform.value.applicationname.replace(/ /g, "_"),
        application_type_name: this.feesform.value.applicationname,
        basic_certificate_fees: this.feesform.value.applicationbasic,
        postal_fees: this.feesform.value.applicationextra
    }
    this.service.post('/Boardadmin_module/addnewappfees',feedata).subscribe((res:any)=>{
            if(res.status=="success"){
              alert(res.Data);
              window.location.reload();
          }
          else{
            alert(res.Data);
              window.location.reload();
          }
      });

  }
}
deletfeesdetails(){
  //  alert(this.selectedappid);
  let conf=confirm("Are you sure to delete This Application Type?")
  if(conf==true){
      let feedata:{feesid:any}={
        feesid: this.selectedappid
      }
      this.service.post('/Boardadmin_module/deleteappfees',feedata).subscribe((res:any)=>{
        if(res.status=="success"){
              alert(res.Data);
              window.location.reload();
          }
          else{
            alert(res.Data);
              window.location.reload();
          }
        });
  }
  
}
}
